import React, { useState } from "react";
import { SeedPhraseDisplay } from "./SeedPhraseDisplay";
import { walletRepository } from "../../../../repositories/WalletRepository";
import { Button } from "../../../../components/Button";
import { ButtonVariant } from "../../../../config/colors";
import { useWallet } from "../../../../hooks/useWallet";

interface SeedPhraseWarningProps {}

export const SeedPhraseWarning: React.FC<SeedPhraseWarningProps> = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { setShouldShowSeed, identityPubkey } = useWallet();

    const handleMarkAsSaved = async () => {  
        if (!identityPubkey) return;

        try {
            setIsLoading(true);
            await walletRepository.markSeedAsSaved(identityPubkey);
            setShouldShowSeed(false);
        } catch (error) {
            console.error("Failed to mark seed as saved:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="flex flex-col gap-4 relative">
                <button
                    onClick={() => setShouldShowSeed(false)}
                    className="absolute top-0 right-0 text-grey dark:text-white opacity-60 hover:opacity-100 transition-opacity"
                    aria-label="Close"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
                <div className="flex flex-col gap-2">
                    <h3 className="font-semibold text-brand-orange">Save Your Seed Phrase</h3>
                    <p className="text-sm opacity-80">
                        We have generated a new self-custodial wallet for you. Please save these 12 words in a secure location to protect your funds. Without this seed phrase, you will not be able to recover your wallet.
                    </p>
                </div>
            </div>
            <SeedPhraseDisplay ghostButton={true} />
            <Button
                onClick={handleMarkAsSaved}
                disabled={isLoading}
                variant={ButtonVariant.primary}
            >
                I Have Saved My Seed Phrase
            </Button>
        </>
    );
};
